/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvc3RhdGlzdGljcy9kb25hdGlvbi9yYXctZGF0YS1hbm9ueW1vdXMtZ2l2aW5ncy9yYXctZGF0YS1hbm9ueW1vdXMtZ2l2aW5ncy5jb21wb25lbnQuc2NzcyJ9 */"];
export { styles as styles };
